import React from 'react';

function Histoire() {

    return (
        <div>
            <div className='page'>
                <h1>Histoire</h1>
            </div>
        </div>
    );
}

export default Histoire;